import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Inject,
  OnDestroy
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { MatSelectChange } from '@angular/material/select';
import { Persona, TipoRol } from '@rpe/registro-personas-empresas-lib';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Laboratorio } from '../../../../actividades/entity-laboratorios/laboratorios.model';
import { Integrante } from '../../../../roles/integrante/integrante.model';
import {
  FileService,
  NotificationService
} from 'projects/registro-personas-empresas/src/app/core/core.module';
import { selectAllTiposRol } from '../../../../roles/entity-tipos-rol/entity-tipos-rol.selectors';
import { Subscription } from 'rxjs';
import { NaturalezaJuridica } from '../../../entity-naturalezas-juridica/naturalezas-juridica.model';
import { selectEntidadesProductivaFromCurrentEmpresa } from '../../../entity-entidad-productiva/entity-entidades-productiva.selectors';
import { PersonasJuridica } from '../../../entity-personas-juridica/entity-personas-juridica.model';
import { EntidadesProductiva } from '../../../entity-entidad-productiva/entity-entidades-productiva.model';
import { certificado_notarial_tooltip } from 'projects/registro-personas-empresas/src/app/shared/util/util';
import { entityRolChangeRequest } from '../../../../roles/entity-roles/entity-roles.actions';
import { selectIntegrantesCurrentEmpresa } from '../../../../roles/entity-integrante/entity-integrante.selectors';
import { selectAllLaboratoriosFromCurrentEmpresa } from '../../../../actividades/entity-laboratorios/laboratorios.selectors';
import { take, tap } from 'rxjs/operators';
import { emailValidator } from 'projects/registro-personas-empresas/src/app/shared/validators/email-validators';
import {
  entityIntegranteChangeRequest,
  entityIntegranteChangeSuccess,
  entityIntegranteChangeFailure
} from '../../../../roles/entity-integrante/entity-integrante.actions';

@Component({
  selector: 'rpe-registro-integrante-update-form',
  templateUrl: './registro-integrante-update-form.component.html',
  styleUrls: ['./registro-integrante-update-form.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistroIntegranteUpdateFormComponent
  implements OnInit, OnDestroy
{
  tipoRolSubscription: Subscription;
  entidadProductivaSubscription: Subscription;
  integrantesCurrentEmpresaSubscription: Subscription;
  currentLaboratorioSubscription: Subscription;

  tipo_rol_id: FormControl = new FormControl([null, [Validators.required]]);
  certificado_notarial: FormControl = new FormControl(null, []);
  acreditacion_representacion: FormControl = new FormControl(null, []);
  correo_electronico: FormControl = new FormControl(null, [emailValidator]);

  roles: TipoRol[] = [];
  integrantes: Integrante[] = [];
  allRoles: TipoRol[] = [];

  selectedLabs: number[] = [];
  tecnicosResposables: Integrante[] = [];

  isAnalista: boolean = false;

  // Indica que el cambio de integrante está en curso (subida de archivo y/o PATCH).
  // Mientras es true se muestra un spinner y se deshabilitan las acciones del modal.
  loading: boolean = false;

  linkAcreditacionRepresentacion: string = '';

  entidadProductiva: EntidadesProductiva = null;

  get isTecnicoResponsable(): boolean {
    return String(this.tipo_rol_id.value) === '6';
  }

  // get needCertificadoNotarial(): boolean {
  //   return String(this.tipo_rol_id.value) === '2' || String(this.tipo_rol_id.value) === '3' || String(this.tipo_rol_id.value) === '4' || String(this.tipo_rol_id.value) === '5'
  // }

  get needAcreditacionRepresentacion(): boolean {
    return (
      String(this.tipo_rol_id.value) === '2' ||
      String(this.tipo_rol_id.value) === '3' ||
      String(this.tipo_rol_id.value) === '5'
    );
  }

  get certificadoNotarialTooltip(): string {
    return certificado_notarial_tooltip;
  }

  constructor(
    public store: Store<State>,
    private actions$: Actions,
    public dialogRef: MatDialogRef<RegistroIntegranteUpdateFormComponent>,
    private notificationService: NotificationService,
    private fileService: FileService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      laboratorios: Laboratorio[];
      integrante: Integrante;
      personaJuridica: PersonasJuridica;
      personaFisica: Persona;
      naturalezasJuridicas: NaturalezaJuridica[];
    }
  ) {
    this.linkAcreditacionRepresentacion = data.integrante.rol
      .acreditacion_representacion as unknown as string;
    this.acreditacion_representacion.setValue(
      data.integrante.rol.acreditacion_representacion
    );
  }

  ngOnInit(): void {
    const labs = this.data?.integrante?.rol?.laboratorios_id;
    this.selectedLabs = labs ? [...labs] : [];

    this.tipoRolSubscription = this.store
      .select(selectAllTiposRol)
      .subscribe((roles) => {
        this.allRoles = roles;
        roles
          ? (this.roles = roles.filter((r) => {
              return this.data.personaJuridica ? r.pj : r.pf;
            }))
          : '';
      });

    this.entidadProductivaSubscription = this.store
      .select(selectEntidadesProductivaFromCurrentEmpresa)
      .subscribe((entidadProductiva) => {
        entidadProductiva
          ? (this.entidadProductiva = entidadProductiva[0])
          : '';

        if (this.data.personaJuridica) {
          const naturalezaJuridica = this.data.naturalezasJuridicas.find(
            (nj) => nj.id === this.data.personaJuridica.naturaleza_juridica_id
          );

          if (naturalezaJuridica.id != 15) {
            this.roles = this.roles.filter((rol) => rol.id != 1);
          }
        }
      });

    this.integrantesCurrentEmpresaSubscription = this.store
      .select(selectIntegrantesCurrentEmpresa)
      .subscribe((integrantes) => {
        this.integrantes = integrantes;

        const tecnicoResponsableRol = this.roles.find((rol) => rol.id === 6);

        this.tecnicosResposables = integrantes.filter(
          (integrante) =>
            integrante.rol.tipo_rol_id === tecnicoResponsableRol.id
        );
      });

    this.currentLaboratorioSubscription = this.store
      .pipe(select(selectAllLaboratoriosFromCurrentEmpresa))
      .pipe(
        tap((laboratorios) => {
          if (laboratorios.length <= 0 || !laboratorios.length) {
            this.roles = this.roles.filter((rol) => rol.id != 7);
          } else {
            this.roles = this.allRoles;
          }
        })
      )
      .subscribe();

    this.tipo_rol_id.setValue(this.data.integrante.rol.tipo_rol_id);

    //si tiene tecnico responsable busco el email y lo seteo
    if (this.isTecnicoResponsable) {
      this.correo_electronico.setValidators([
        emailValidator,
        Validators.required
      ]);

      const mailIntegrante = this.integrantes.find(
        (i) => i.rol.id === this.data.integrante.rol.id
      );

      if (mailIntegrante.correo_electronico) {
        this.correo_electronico.setValue(mailIntegrante.correo_electronico);
      }
    }

    this.isAnalista =
      this.roles.find((rol) => {
        return rol.id === this.data.integrante.rol.tipo_rol_id;
      }).id === 7;
  }

  ngOnDestroy(): void {
    this.tipoRolSubscription.unsubscribe();
    this.entidadProductivaSubscription.unsubscribe();
    this.integrantesCurrentEmpresaSubscription.unsubscribe();
  }

  onRolSelect(event: MatSelectChange): void {
    this.tipo_rol_id.setValue(event.value);

    if (this.isTecnicoResponsable) {
      this.correo_electronico.setValidators([
        emailValidator,
        Validators.required
      ]);

      const integrante = this.integrantes.find(
        (i) => i.rol.id === this.data.integrante.rol.id
      );

      if (integrante.correo_electronico) {
        this.correo_electronico.setValue(integrante.correo_electronico);
      }
    } else {
      this.correo_electronico.clearValidators();
    }
  }

  onLabChange($event: MatCheckboxChange, laboratorio: Laboratorio) {
    try {
      if ($event.checked) {
        this.selectedLabs.push(laboratorio.id);
      } else {
        this.selectedLabs = this.selectedLabs.filter(
          (lab) => lab !== laboratorio.id
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  onFileChange(texto: string) {}

  onSubmit() {
    let data: Integrante = {
      nombre_completo: this.data.integrante.nombre_completo,
      documento_persona: this.data.integrante.documento_persona,
      rol: {
        ...this.data.integrante.rol,
        tipo_rol_id: this.tipo_rol_id.value
      },
      laboratorios_id: this.selectedLabs
    } as unknown as Integrante;

    if (this.tipo_rol_id.invalid) {
      this.notificationService.info('Debe seleccionar un rol');
      return;
    }

    if (this.isAnalista && !this.selectedLabs.length) {
      this.notificationService.info('Debe seleccionar al menos un laboratorio');
      return;
    }

    if (this.isTecnicoResponsable && this.correo_electronico.invalid) {
      this.notificationService.info('Debe ingresar un correo electrónico');
      return;
    }

    if (
      this.needAcreditacionRepresentacion &&
      !this.acreditacion_representacion.value
    ) {
      this.notificationService.info(
        'Debe subir un archivo de acreditación de representación'
      );
      return;
    }

    // Solo al CAMBIAR el rol hacia Apoderado/Representante el backend exige un archivo
    // de acreditación nuevo en Base64; no acepta reutilizar el ya almacenado
    // (linkAcreditacionRepresentacion). Si el rol no cambia y ya existe el archivo
    // cargado en el modal, se reutiliza el almacenado y no se debe exigir uno nuevo.
    const rolModificado =
      Number(this.data.integrante.rol.tipo_rol_id) !==
      Number(this.tipo_rol_id.value);

    if (
      this.needAcreditacionRepresentacion &&
      this.linkAcreditacionRepresentacion &&
      rolModificado
    ) {
      this.notificationService.error(
        'Debe adjuntar un nuevo archivo de acreditación de representación para completar el cambio de rol.'
      );
      return;
    }

    if (this.isTecnicoResponsable) {
      //Si es tecnico responsable seteo el correo electronico
      data = {
        ...data,
        correo_electronico: this.correo_electronico.value
      };
    }

    if (this.isTecnicoResponsable && this.correo_electronico.invalid) {
      this.notificationService.info('Debe ingresar un correo electrónico');
      return;
    }

    if (this.isTecnicoResponsable) {
      data = {
        ...data,
        correo_electronico: this.correo_electronico.value
      };
    }

    if (this.isAnalista && !this.selectedLabs.length) {
      this.notificationService.info('Debe seleccionar al menos un laboratorio');
      return;
    }

    // Si no requiere archivo, lo borro del body y despacho directamente.
    if (!this.isFileRequired(data.rol.tipo_rol_id)) {
      delete data.rol.acreditacion_representacion;
      this.dispatchIntegranteChange(data);
      return;
    }

    // Requiere archivo y se adjuntó uno nuevo (no hay link): primero lo subo y
    // recién después despacho el cambio. El spinner cubre también la subida.
    if (!this.linkAcreditacionRepresentacion) {
      this.loading = true;
      this.fileService.uploadFile(this.acreditacion_representacion.value).subscribe({
        next: (file) => {
          this.dispatchIntegranteChange({
            ...data,
            rol: {
              ...data.rol,
              acreditacion_representacion: file
            }
          });
        },
        error: () => {
          this.loading = false;
          this.notificationService.error(
            'No se pudo subir el archivo de acreditación de representación. Intente nuevamente.'
          );
        }
      });
      return;
    }

    // Requiere archivo pero se reutiliza el ya almacenado (hay link): no se envía
    // el archivo al backend.
    delete data.rol.acreditacion_representacion;
    this.dispatchIntegranteChange(data);
  }

  // Despacha el cambio de integrante mostrando un spinner mientras la request está
  // en curso. Cierra el modal al recibir el success y lo mantiene abierto ante un
  // failure para que el usuario pueda corregir y reintentar (el effect ya notifica).
  private dispatchIntegranteChange(data: Integrante): void {
    this.loading = true;

    this.actions$
      .pipe(
        ofType(entityIntegranteChangeSuccess, entityIntegranteChangeFailure),
        take(1)
      )
      .subscribe((action) => {
        this.loading = false;
        if (action.type === entityIntegranteChangeSuccess.type) {
          this.dialogRef.close();
        }
      });

    this.store.dispatch(
      entityIntegranteChangeRequest({
        item: data as any
      })
    );
  }

  // Si el rol es 2, 3 o 5, se requiere el archivo de acreditacion de representacion
  isFileRequired(tipoRolId: number): boolean {
    return tipoRolId === 2 || tipoRolId === 3 || tipoRolId === 5;
  }

  uploadNewCertificadoNotarial(): void {
    this.linkAcreditacionRepresentacion = '';
    this.acreditacion_representacion.setValue(null);
    this.acreditacion_representacion.setValidators([Validators.required]);
    this.acreditacion_representacion.updateValueAndValidity();
  }

  private processUrl(url: string): string {
    // Buscar el inicio de la parte "/rpe"
    const urlStart = '/rpe';
    const index = url.indexOf(urlStart);

    if (index === -1) {
      throw new Error(`La URL proporcionada no contiene la ruta '${urlStart}'`);
    }

    // Extraer y retornar la parte de la URL desde /rpe en adelante
    return url.substring(index);
  }
}
